import React, { useEffect, useState } from 'react'
import {
  Container,
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap'
import { PlayCircle, UserPlus } from 'react-feather'
import BreadCrumbs from 'components/breadcrumbs'
import { useNavigate } from 'react-router-dom'
import CustomButton from 'components/Buttons/CustomButton'
import { URL_PROCESS, URL_SESSION_JOIN } from 'utils/pathUrl'
import {
  useAddEditSessionMutation,
  useFetchSessionQuery,
  useLazyFetchSessionQuery,
} from '../processApiSlice'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import { setSessionProcess } from 'features/public-views/login/loginSlice'
import PMBProjectSelections from 'components/PMBProjectSelections'

const Session = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [payload, setPayload] = useState({
    isAutoCloseOnEOD: true,
    isMultiUser: true,
  })
  const [selectedProject, setSelectedProject] = useState(null)

  const [triggerFetchSession] = useLazyFetchSessionQuery()
  const [addOrEditSession, response] = useAddEditSessionMutation()

  const { sessionProcess } = useSelector((s) => s.auth)

  const generateShortUuidLot = (prefix = 'SES') => {
    const now = new Date()

    const y = now.getFullYear()
    const m = String(now.getMonth() + 1).padStart(2, '0')
    const d = String(now.getDate()).padStart(2, '0')

    const hh = String(now.getHours()).padStart(2, '0')
    const mm = String(now.getMinutes()).padStart(2, '0')

    return `${prefix}-${y}${m}${d}-${hh}${mm}`
  }

  const handleSubmit = async () => {
    try {
      const res = await addOrEditSession({
        ...payload,
        isAutoCloseOnEOD: payload?.isAutoCloseOnEOD ? 1 : 0,
        projectId: selectedProject?.value || selectedProject?.id,
      })
      if (res?.error) {
        throw res
      }
      dispatch(setSessionProcess({ ...res?.data, project: selectedProject }))

      navigate(URL_PROCESS, { state: res })
    } catch (error) {
      enqueueSnackbar(error?.message ?? error?.error?.data?.message, {
        variant: 'error',
      })
    }
  }

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await triggerFetchSession()
        const freshSession = res?.data
        if (!freshSession) {
          dispatch(setSessionProcess(null))
        } else {
          dispatch(setSessionProcess(freshSession))
          navigate(URL_PROCESS)
        }
      } catch (err) {
        console.error('Failed to fetch session:', err)
        dispatch(setSessionProcess(null))
      }
    }

    checkSession()
  }, [sessionProcess])

  useEffect(() => {
    setPayload((prev) => ({
      ...prev,
      title: generateShortUuidLot('SES', 8),
    }))
  }, [])

  return (
    <div className="w-100 px-3 pb-3">
      <Container className="custom-container">
        {/* Breadcrumb */}
        <div className="pt-3">
          <BreadCrumbs breadCrumbActive={'Sesi Proses Produksi'} />
        </div>

        {/* Page Content */}
        <Card className="shadow-sm rounded-3 border-0">
          <CardBody className="text-center p-4">
            {/* Icon + Title */}
            <div className="mb-3">
              <PlayCircle size={42} className="text-primary mb-2" />
              <h5 className="fw-bold mb-1">Mulai Sesi Produksi</h5>
              <p className="text-muted mb-4">Mulai mencatat proses produksi</p>
            </div>

            {/* Session Info */}
            <div className="text-start">
              <FormGroup className="mb-3">
                <Label className="fw-semibold">ID Sesi</Label>
                <Input
                  type="text"
                  value={payload?.title}
                  placeholder="Masukkan ID Sesi"
                  onChange={(e) => {
                    setPayload((prevState) => {
                      return { ...prevState, title: e?.target?.value }
                    })
                  }}
                  data-testid="process-session-id-input"
                />
              </FormGroup>

              <FormGroup>
                <h6 className="fw-semibold">Project (Opsional)</h6>

                <PMBProjectSelections
                  style={{
                    borderColor: 'white',
                    caretColor: 'transparent',
                  }}
                  className="border-input button w-100"
                  placeholder="Pilih project"
                  value={selectedProject}
                  onChange={(project) => setSelectedProject(project)}
                  testId="process-session-project"
                />
              </FormGroup>

              <FormGroup className="d-flex align-items-center justify-content-between">
                <div>
                  <Label className="fw-semibold mb-0">
                    Tutup otomatis di akhir hari
                  </Label>
                  <p className="text-muted small mb-0">
                    Sesi akan berakhir otomatis pada tengah malam{' '}
                  </p>
                </div>
                <div>
                  <FormGroup switch>
                    <Input
                      role="switch"
                      type="switch"
                      id="autoCloseSwitch"
                      defaultChecked
                      checked={payload?.isAutoCloseOnEOD}
                      data-testid="process-session-autoclose-switch"
                      onChange={() => {
                        const value = payload.isAutoCloseOnEOD
                          ? !payload.isAutoCloseOnEOD
                          : !payload.isAutoCloseOnEOD
                        setPayload((prevState) => {
                          return { ...prevState, isAutoCloseOnEOD: value }
                        })
                      }}
                    />
                  </FormGroup>
                </div>
              </FormGroup>

              {/* <FormGroup className="d-flex align-items-center justify-content-between">
                <div>
                  <Label className="fw-semibold mb-0">
                    Izinkan orang lain bergabung
                  </Label>
                  <p className="text-muted small mb-0">
                    Aktifkan kolaborasi multi pengguna
                  </p>
                </div>
                <div>
                  <FormGroup switch>
                    <Input
                      role="switch"
                      type="switch"
                      id="multiUserSwitch"
                      defaultChecked
                      checked={payload?.isMultiUser}
                      onChange={() => {
                        const value = payload.isMultiUser
                          ? !payload.isMultiUser
                          : !payload.isMultiUser
                        setPayload((prevState) => {
                          return { ...prevState, isMultiUser: value }
                        })
                      }}
                    />
                  </FormGroup>
                </div>
              </FormGroup> */}
            </div>

            {/* Button */}
            <CustomButton
              onClick={handleSubmit}
              color="primary"
              disabled={!payload?.title}
              className="mt-4 w-100"
              block
              testId="process-session-start-button"
            >
              <PlayCircle size={16} className="me-1" />
              Mulai Sesi
            </CustomButton>
            {/* <CustomButton
              onClick={() => navigate(URL_SESSION_JOIN)}
              color="primary"
              outline
              className="mt-2 w-100"
              block
            >
              <UserPlus size={16} className="me-1" />
              Gabung Sesi yang Ada
            </CustomButton> */}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default Session
